// Stanorai Trustpilot stats
export const trustpilotStats = {
    overallRating: 4.0,
    totalReviews: 3,
    ratingLabel: 'Great'
};
// Actual Trustpilot reviews for Stanorai
export const reviews = [
    {
        author: 'Cameron Dixon',
        initials: 'CD',
        reviewCount: 1,
        rating: 5,
        title: 'We\'ve tried several hiring tools',
        text: 'We\'ve tried several hiring tools, but we prefer Stanor because it\'s tailored to our high-volume frontline hiring needs. The scoring is accurate and saves our hiring managers hours. A great product overall.',
        date: 'January 19, 2026',
        daysAgo: 'Feb 2, 2026',
        isVerified: true
    },
    {
        author: 'Ben Thomson',
        initials: 'BT',
        reviewCount: 1,
        rating: 5,
        title: 'We\'ve been using Stanor for several months',
        text: 'We\'ve been using Stanor for several months and really like it. It saves us hours every week.',
        date: 'January 14, 2026',
        daysAgo: 'Feb 1, 2026',
        isVerified: true
    },
    {
        author: 'Wyatt Barron',
        initials: 'WB',
        reviewCount: 1,
        rating: 5,
        title: 'Stanor delivers on what it promises',
        text: 'Stanor delivers on what it promises; the features work as described.',
        date: 'January 6, 2026',
        daysAgo: 'Jan 27, 2026',
        isVerified: true
    }
];
